const state = {
  accessToken: localStorage.getItem('auth.accessToken') || '',
  accessTokenExpired: false,
  user: {
    id: null,
    name: null,
    email: null,
    cpf: null,
    phone: null,
    birthdate: null,
    zip: null,
    state: null,
    city: null,
    street: null,
    number: null,
    district: null,
    complement: null,
    admin: false,
    role: null,
    organization: {
      id: null,
      name: null,
      cnpj: null,
    },
    organizationPlan: {
      plan_id: null,
      auto_recharge_value: null,
      cancellation_date: null,
      next_plan_id: null,
      change_date: null,
      subscribe_date: null,
      next_charge_date: null,
    },
    plan: {
      id: null,
      prepaid: null,
      name: null,
      price: null,
      price_per_consultation: null,
    },
  },
  tokens: [],
  invite: {
    name: null,
    email: null,
    organizationName: null,
  },
  users: [],
  invites: [],
  role: {
    master: 1,
    operador: 2,
  },
};

export default state;
